import {
	UntypedFormArray,
	UntypedFormGroup,
	UntypedFormControl,
	Validators,
} from '@angular/forms';
import { Validation } from './validation.model';
import { BaseResponse } from './base-response.model';
import { StringUtility } from '../utility/string.utility';

export class UserPhoneInfoResponse extends BaseResponse {
	constructor(
		public message: string,
		public phone: UserPhoneInfoJSON[]
	) {
		super(message);
	}
}

export interface UserPhoneInfoJSON {
	id: number;
	numberType: string;
	phone: string;
}

export class UserPhoneInfo {
	constructor(
		public id: number,
		public numberType: string,
		public phone: string
	) {}

	static fromJSON(json: UserPhoneInfoJSON): UserPhoneInfo {
		return Object.assign(Object.create(UserPhoneInfo.prototype), json, {});
	}

	static fromFormArray(fa: UntypedFormArray): UserPhoneInfo[] {
		return fa.length > 0
			? fa.controls.map((fg: UntypedFormGroup) => this.fromFormGroup(fg))
			: [];
	}

	static fromFormGroup(fg: UntypedFormGroup): UserPhoneInfo {
		return Object.assign(Object.create(UserPhoneInfo.prototype), {
			id: fg.value['id'],
			numberType: fg.value['numberType'],
			phone: fg.value['phone'],
		});
	}

	static createPhoneFormArray(
		phones: UserPhoneInfo[],
		validation: Validation
	): UntypedFormArray {
		return phones
			? new UntypedFormArray(
					phones.map((phone) =>
						this.createPhoneFormGroup(phone, validation)
					)
				)
			: new UntypedFormArray([]);
	}

	static createPhoneFormGroup(
		phone: UserPhoneInfo,
		validation: Validation
	): UntypedFormGroup {
		const fg = new UntypedFormGroup({
			id: new UntypedFormControl(phone ? phone.id : null),
			numberType: new UntypedFormControl(
				phone ? phone.numberType : null,
				[Validators.required]
			),
			phone: new UntypedFormControl(
				phone
					? StringUtility.ensureFirstCharacterIsPlus(phone.phone)
					: '',
				[
					Validators.required,
					Validators.maxLength(validation.phone.maxLength),
					Validators.pattern(validation.phone.pattern),
				]
			),
		});
		StringUtility.ensureFormControlFirstCharacterIsPlus(
			fg.get('phone') as UntypedFormControl
		);
		return fg;
	}
}
